(function () {
  var root = document.getElementById('eculab-chat');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';
  root.hidden = false;

  /* ================= Config & state ================= */
  var cfg = {};
  try { cfg = JSON.parse(root.querySelector('[data-chat-config]').textContent); } catch (e) {}
  var P = cfg.products || {};
  var CTX = { tpl: root.dataset.template || '', handle: root.dataset.product || '' };
  var ROOT_URL = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var $ = function (s, c) { return (c || root).querySelector(s); };
  var log = $('[data-chat-log]'), panel = $('.eculab-chat__panel'), fab = $('.eculab-chat__fab');
  var input = $('[data-chat-input]'), teaser = $('[data-chat-teaser]'), sugg = $('[data-chat-sugg]');
  var VEH = null, PACK = null, VIDX = null, mode = null, lastBot = null, busy = 0;
  var KEY = 'eculab_chat_v2';
  var MODES = { O: 'OBD', B: 'Bench', T: 'Boot', D: 'BDM', J: 'JTAG', N: 'NBD' };
  var STAGE = { O: 'Original', '1': 'Stage 1', '2': 'Stage 2', '3': 'Stage 3', '4': 'Stage 4', '5': 'Stage 5' };
  var OPT = { D: 'DPF/FAP OFF', E: 'EGR OFF', L: 'Lambda OFF', A: 'AdBlue OFF', V: 'Vmax OFF', T: 'DTC OFF', F: 'Clapets OFF' };
  var NAMES = { kess: 'Kess V2', ktag: 'KTAG', kt200: 'KT200', kt200ii: 'KT200II', mpps: 'MPPS', kdcan: 'Câble K+DCAN', enet: 'Câble ENET', icom: 'ICOM NEXT', bmwscan: 'BMW Scanner', ista: 'ISTA+', autocom: 'Diagnostic multimarque', pack: 'Pack 21 000 cartographies' };
  var REPROG = ['kess', 'ktag', 'kt200', 'kt200ii', 'mpps'];
  var IC = {
    car: '<svg viewBox="0 0 24 24"><path d="M4 13.5l1.8-4.6A2 2 0 0 1 7.7 7.6h8.6a2 2 0 0 1 1.9 1.3l1.8 4.6M3.5 13.5h17v3.5a1 1 0 0 1-1 1h-15a1 1 0 0 1-1-1z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/><circle cx="7.5" cy="15.7" r="1.1" fill="currentColor"/><circle cx="16.5" cy="15.7" r="1.1" fill="currentColor"/><path d="M5.5 18v1.5M18.5 18v1.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>',
    db: '<svg viewBox="0 0 24 24"><ellipse cx="12" cy="6" rx="7" ry="2.6" fill="none" stroke="currentColor" stroke-width="1.8"/><path d="M5 6v6c0 1.4 3.1 2.6 7 2.6s7-1.2 7-2.6V6M5 12v6c0 1.4 3.1 2.6 7 2.6s7-1.2 7-2.6v-6" fill="none" stroke="currentColor" stroke-width="1.8"/></svg>',
    pulse: '<svg viewBox="0 0 24 24"><path d="M3 12h4l2-5 4 10 2-5h6" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    box: '<svg viewBox="0 0 24 24"><path d="M3.5 7.5 12 3l8.5 4.5v9L12 21l-8.5-4.5z M3.5 7.5 12 12l8.5-4.5M12 12v9" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg>',
    cart: '<svg viewBox="0 0 24 24"><path d="M3 4h2l2.2 10.2a1.5 1.5 0 0 0 1.5 1.2h8.6a1.5 1.5 0 0 0 1.5-1.1L20.5 8H6.2" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/><circle cx="9.5" cy="19.5" r="1.3" fill="currentColor"/><circle cx="17" cy="19.5" r="1.3" fill="currentColor"/></svg>',
    check: '<svg viewBox="0 0 24 24"><path d="M5 12.5l4.5 4.5L19 7.5" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    x: '<svg viewBox="0 0 24 24"><path d="M7 7l10 10M17 7 7 17" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg>',
    search: '<svg viewBox="0 0 24 24"><circle cx="11" cy="11" r="6.5" fill="none" stroke="currentColor" stroke-width="1.9"/><path d="M16 16l4 4" stroke="currentColor" stroke-width="1.9" stroke-linecap="round"/></svg>'
  };

  /* ================= Utils ================= */
  function store(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v); } catch (e) { return null; } }
  function fold(s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9.+]+/g, ' ').trim(); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function el(tag, cls, html) { var d = document.createElement(tag); if (cls) d.className = cls; if (html != null) d.innerHTML = html; return d; }
  function lev1(a, b) { /* edit distance <= 1 */
    if (a === b) return true; var la = a.length, lb = b.length; if (Math.abs(la - lb) > 1) return false;
    var i = 0, j = 0, e = 0;
    while (i < la && j < lb) { if (a[i] === b[j]) { i++; j++; continue; } if (++e > 1) return false; if (la > lb) i++; else if (lb > la) j++; else { i++; j++; } }
    return e + (la - i) + (lb - j) <= 1;
  }
  function near(a, b) { return a === b || (a.length > 4 && b.length > 4 && (a.slice(0, 5) === b.slice(0, 5) || lev1(a, b))); }
  function scroll() { var t = log.scrollHeight; if (lastBot) t = Math.min(t, lastBot.offsetTop - 14); log.scrollTo({ top: t, behavior: 'smooth' }); }
  function save() {
    var items = [];
    log.querySelectorAll('[data-m]').forEach(function (m) {
      var c = m.cloneNode(true); c.querySelectorAll('.eculab-chat__pick, .eculab-chat__vs').forEach(function (x) { x.remove(); });
      items.push(c.outerHTML);
    });
    store(KEY, JSON.stringify(items.slice(-40)));
  }

  /* ================= Rendering ================= */
  function user(text) {
    lastBot = null;
    var m = el('div', 'eculab-chat__row is-user'); m.setAttribute('data-m', '');
    m.innerHTML = '<div class="eculab-chat__msg">' + esc(text) + '</div>';
    log.appendChild(m); scroll(); save();
  }
  function bot(html, opt) {
    opt = opt || {};
    var row = el('div', 'eculab-chat__row is-bot');
    row.innerHTML = '<span class="eculab-chat__ava" aria-hidden="true"></span><div class="eculab-chat__msg is-typing"><i></i><i></i><i></i></div>';
    log.appendChild(row); scroll(); busy++;
    var plain = String(html).replace(/<[^>]+>/g, '');
    var delay = opt.delay != null ? opt.delay : Math.min(1200, 380 + plain.length * 3);
    return new Promise(function (res) {
      setTimeout(function () {
        busy--;
        var msg = row.querySelector('.eculab-chat__msg');
        msg.className = 'eculab-chat__msg' + (opt.wide ? ' is-wide' : '');
        msg.innerHTML = html;
        row.setAttribute('data-m', '');
        row.classList.add('is-in');
        lastBot = row; scroll(); save(); res(msg);
      }, delay);
    });
  }
  function chips(list) {
    var box = el('div', 'eculab-chat__chips');
    list.forEach(function (c) {
      var b = el(c.href ? 'a' : 'button', 'eculab-chat__chip' + (c.primary ? ' is-primary' : ''));
      b.innerHTML = (c.icon ? IC[c.icon] : '') + '<span>' + esc(c.label) + '</span>';
      if (c.href) { b.href = c.href; if (c.blank) { b.target = '_blank'; b.rel = 'noopener'; } }
      else { b.type = 'button'; b.addEventListener('click', function () { clearChips(); user(c.label); c.run(); }); }
      box.appendChild(b);
    });
    log.appendChild(box); scroll();
  }
  function clearChips() { log.querySelectorAll('.eculab-chat__chips').forEach(function (c) { c.remove(); }); }
  function priceTxt(p) { return p ? (p.v ? 'dès ' : '') + p.p : ''; }
  function card(id, opts) {
    opts = opts || {};
    var p = P[id]; var name = p ? p.t : NAMES[id];
    var img = p && p.i ? '<img src="' + esc(p.i) + '" alt="" loading="lazy" width="56" height="56">' : '<span class="eculab-chat__ph">' + IC.box + '</span>';
    var tags = (opts.tags || []).map(function (t) { return '<span class="eculab-chat__tag' + (t.cls ? ' ' + t.cls : '') + '">' + esc(t.t) + '</span>'; }).join('');
    var actions = p ? '<div class="eculab-chat__acts"><a href="' + esc(p.u) + '" class="eculab-chat__btn">Voir</a>' + (p.vid && p.av !== false ? '<button type="button" class="eculab-chat__btn is-cart" data-add="' + esc(p.vid) + '" data-name="' + esc(name) + '">' + IC.cart + '<span>Ajouter</span></button>' : '') + '</div>' : '';
    return '<div class="eculab-chat__card' + (opts.dim ? ' is-dim' : '') + (opts.hl ? ' is-hl' : '') + '">' + img +
      '<div class="eculab-chat__ci"><div class="eculab-chat__ct"><strong>' + esc(name) + '</strong>' + (p ? '<span class="eculab-chat__price">' + esc(priceTxt(p)) + '</span>' : '') + '</div>' +
      (tags ? '<div class="eculab-chat__tags">' + tags + '</div>' : '') + (opts.note ? '<small>' + opts.note + '</small>' : '') + actions + '</div></div>';
  }

  /* ================= Home ================= */
  function toolFromHandle() {
    if (!CTX.handle) return null;
    for (var k in P) if (P[k] && P[k].u && P[k].u.split('?')[0].replace(/\/$/, '').split('/').pop() === CTX.handle) return k;
    return null;
  }
  function home() {
    var ctxTool = toolFromHandle();
    var hello = '<p class="eculab-chat__hello">' + esc(cfg.welcome || 'Bonjour 👋') + '</p>';
    if (ctxTool && REPROG.indexOf(ctxTool) >= 0) hello += '<p class="eculab-chat__ctx">Vous regardez le <strong>' + esc((P[ctxTool] || {}).t || NAMES[ctxTool]) + '</strong>. Je peux vérifier tout de suite s’il est compatible avec votre véhicule.</p>';
    else if (ctxTool === 'pack') hello += '<p class="eculab-chat__ctx">Vous regardez le <strong>Pack 21 000 cartographies</strong>. Donnez-moi votre véhicule, je regarde s’il est dedans.</p>';
    var tiles = [
      { k: 'finder', icon: 'car', t: 'Trouver mon outil', d: 'Interface compatible avec votre véhicule' },
      { k: 'pack', icon: 'db', t: 'Pack 21 000', d: 'Votre véhicule est-il dedans ?' },
      { k: 'diag', icon: 'pulse', t: 'Diagnostic', d: 'BMW / MINI ou multimarque' },
      { k: 'ship', icon: 'box', t: 'Commande', d: 'Livraison, paiement, téléchargement' }
    ];
    bot(hello + '<div class="eculab-chat__tiles">' + tiles.map(function (t) {
      return '<button type="button" class="eculab-chat__tile" data-go="' + t.k + '">' + IC[t.icon] + '<strong>' + t.t + '</strong><span>' + t.d + '</span></button>';
    }).join('') + '</div>', { delay: 250, wide: true }).then(function () {
      if (ctxTool && REPROG.indexOf(ctxTool) >= 0) chips([{ label: 'Vérifier la compatibilité du ' + ((P[ctxTool] || {}).t || NAMES[ctxTool]), primary: true, run: function () { finder(null, null, ctxTool); } }]);
      else if (ctxTool === 'pack') chips([{ label: 'Chercher mon véhicule dans le pack', primary: true, run: packAsk }]);
    });
  }
  var GO = {
    finder: function () { finder(); }, pack: function () { packAsk(); }, diag: function () { diag(); },
    ship: function () { faqTopic('livraison delai paiement colis telechargement', 'Livraison, paiement, téléchargement : voici les questions les plus posées.'); }
  };
  var GOLABEL = { finder: 'Trouver l’outil pour mon véhicule', pack: 'Mon véhicule est-il dans le pack 21 000 ?', diag: 'Diagnostic', ship: 'Commande, livraison et paiement' };
  function menu(text) {
    bot(text || 'Que puis-je faire d’autre pour vous ?').then(function () {
      chips([
        { label: 'Trouver mon outil', icon: 'car', run: GO.finder },
        { label: 'Pack 21 000', icon: 'db', run: GO.pack },
        { label: 'Diagnostic', icon: 'pulse', run: GO.diag },
        { label: 'Parler à quelqu’un', run: contact }
      ]);
    });
  }

  /* ================= Contact ================= */
  function contact() {
    bot('Notre équipe vous répond rapidement. Pour aller plus vite, indiquez la <strong>marque, le modèle, l’année et la motorisation</strong> (et si possible une photo de l’étiquette du calculateur).').then(function () {
      var list = [];
      if (cfg.whatsapp) list.push({ label: 'WhatsApp', primary: true, href: 'https://wa.me/' + String(cfg.whatsapp).replace(/\D/g, '') + '?text=' + encodeURIComponent('Bonjour EcuLab, ' + transcriptHint()), blank: true });
      if (cfg.email) list.push({ label: cfg.email, href: 'mailto:' + cfg.email + '?subject=' + encodeURIComponent('Question depuis le site') + '&body=' + encodeURIComponent(transcriptHint()) });
      list.push({ label: 'Formulaire de contact', href: cfg.contact || '/pages/contact' });
      list.push({ label: 'Autre question', run: function () { menu(); } });
      chips(list);
    });
  }
  function transcriptHint() {
    var last = [].slice.call(log.querySelectorAll('.eculab-chat__row.is-user .eculab-chat__msg')).slice(-3).map(function (m) { return m.textContent; });
    return last.length ? 'ma demande : ' + last.join(' / ') : '';
  }

  /* ================= Diagnostic ================= */
  function diag() {
    bot('Pour quel véhicule ?').then(function () {
      chips([
        { label: 'BMW / MINI série E', run: function () { diagRes('E'); } },
        { label: 'BMW / MINI série F / G', run: function () { diagRes('F'); } },
        { label: 'BMW, je ne sais pas', run: function () { diagRes('X'); } },
        { label: 'Autre marque', run: function () { diagRes('M'); } }
      ]);
    });
  }
  function diagRes(k) {
    var S = {
      E: ['Pour les <strong>BMW / MINI série E</strong> (E46, E90, E60, E87… environ 1995–2013) :', [['kdcan', 'Recommandé'], ['bmwscan', 'Anciennes BMW'], ['ista', 'Logiciel']]],
      F: ['Pour les <strong>BMW / MINI série F et G</strong> (F30, F10, G20, G30…) :', [['enet', 'Recommandé'], ['icom', 'Pro atelier'], ['ista', 'Logiciel']]],
      X: ['L’<strong>ICOM NEXT</strong> couvre toutes les générations depuis 2004. Astuce : le code châssis (E90, F30…) figure sur l’étiquette du montant de porte.', [['icom', 'Toutes générations'], ['kdcan', 'Série E'], ['enet', 'Série F / G']]],
      M: ['Pour les autres marques, notre solution de <strong>diagnostic multimarque</strong> :', [['autocom', 'Multimarque']]]
    }[k];
    bot(S[0] + '<div class="eculab-chat__cards">' + S[1].map(function (x, i) { return card(x[0], { tags: [{ t: x[1], cls: i ? '' : 'is-ok' }], hl: !i }); }).join('') + '</div>', { wide: true }).then(function () { menu('Autre chose ?'); });
  }

  /* ================= Vehicle finder ================= */
  function loadVeh() {
    if (VEH) return Promise.resolve(VEH);
    return fetch(root.dataset.vehUrl).then(function (r) { return r.json(); }).then(function (d) { VEH = d; return d; });
  }
  function buildIdx() {
    if (VIDX) return VIDX;
    VIDX = [];
    VEH.brands.forEach(function (b, bi) { b[1].forEach(function (m, mi) { m[1].forEach(function (e, ei) { VIDX.push({ bi: bi, mi: mi, ei: ei, k: ' ' + fold(b[0] + ' ' + m[0] + ' ' + e[0] + ' ' + e[1]) + ' ' }); }); }); });
    return VIDX;
  }
  function vsearch(q) {
    var w = fold(q).split(' ').filter(Boolean); if (!w.length) return [];
    var out = [], idx = buildIdx();
    for (var i = 0; i < idx.length && out.length < 60; i++) {
      var k = idx[i].k, ok = true;
      for (var j = 0; j < w.length; j++) { if (k.indexOf(w[j]) < 0) { ok = false; break; } }
      if (ok) out.push(idx[i]);
    }
    return out;
  }
  function finder(prefBrand, prefModel, focusTool, prefQuery) {
    var intro = focusTool ? 'Quel est votre véhicule ? Je vérifie la compatibilité du <strong>' + esc((P[focusTool] || {}).t || NAMES[focusTool]) + '</strong>.' : 'Quel est votre véhicule ? Tapez-le, ou choisissez dans la liste.';
    bot(intro).then(function (msg) {
      loadVeh().then(function (d) {
        var w = el('div', 'eculab-chat__vs');
        w.innerHTML = '<label class="eculab-chat__vsbox">' + IC.search + '<input type="text" placeholder="Ex : Golf 7 2.0 TDI, 320d, Clio dCi…" autocomplete="off" aria-label="Rechercher votre véhicule"></label><ul class="eculab-chat__vsl" role="listbox"></ul><button type="button" class="eculab-chat__link" data-list>Choisir dans la liste ↓</button>';
        var inp = w.querySelector('input'), ul = w.querySelector('ul');
        var t;
        inp.addEventListener('input', function () {
          clearTimeout(t);
          t = setTimeout(function () {
            var r = vsearch(inp.value);
            ul.innerHTML = r.slice(0, 7).map(function (x, i) {
              var b = d.brands[x.bi], m = b[1][x.mi], e = m[1][x.ei];
              return '<li role="option" tabindex="-1" data-i="' + i + '"><strong>' + esc(b[0] + ' ' + m[0]) + '</strong><span>' + esc(e[0]) + (e[1] ? ' · ' + esc(e[1]) : '') + '</span></li>';
            }).join('') + (r.length > 7 ? '<li class="is-more">' + (r.length >= 60 ? '60+' : r.length) + ' résultats : précisez la motorisation</li>' : '') + (!r.length && inp.value.trim().length > 2 ? '<li class="is-more">Aucun résultat : essayez « marque + modèle »</li>' : '');
            ul._r = r; scroll();
          }, 120);
        });
        function pick(x) {
          var b = d.brands[x.bi], m = b[1][x.mi], e = m[1][x.ei];
          w.remove(); user(b[0] + ' ' + m[0] + ' · ' + e[0]); finderRes(e, focusTool, m[0] + ' ' + e[0], b[0]);
        }
        ul.addEventListener('click', function (ev) { var li = ev.target.closest('li[data-i]'); if (li) pick(ul._r[+li.dataset.i]); });
        inp.addEventListener('keydown', function (ev) {
          var items = ul.querySelectorAll('li[data-i]'); if (!items.length) return;
          var cur = ul.querySelector('li.is-act'), i = cur ? +cur.dataset.i : -1;
          if (ev.key === 'ArrowDown' || ev.key === 'ArrowUp') { ev.preventDefault(); i = ev.key === 'ArrowDown' ? Math.min(items.length - 1, i + 1) : Math.max(0, i - 1); items.forEach(function (li) { li.classList.toggle('is-act', +li.dataset.i === i); }); }
          if (ev.key === 'Enter') { ev.preventDefault(); pick(ul._r[i < 0 ? 0 : i]); }
        });
        w.querySelector('[data-list]').addEventListener('click', function () { w.querySelector('[data-list]').remove(); listPicker(w, d, focusTool); });
        msg.appendChild(w);
        if (prefBrand != null) { w.querySelector('[data-list]').remove(); listPicker(w, d, focusTool, prefBrand, prefModel); }
        else if (prefQuery) { inp.value = prefQuery; inp.dispatchEvent(new Event('input')); }
        else setTimeout(function () { inp.focus({ preventScroll: true }); }, 60);
        scroll();
      }).catch(function () { bot('Je n’arrive pas à charger la liste des véhicules. Contactez-nous, on vérifie pour vous.').then(contact); });
    });
  }
  function listPicker(w, d, focusTool, pb, pm) {
    var f = el('div', 'eculab-chat__pick');
    f.innerHTML = '<select data-b><option value="">Marque</option></select><select data-mm disabled><option value="">Modèle</option></select><select data-e disabled><option value="">Motorisation · calculateur</option></select>';
    var sb = f.querySelector('[data-b]'), sm = f.querySelector('[data-mm]'), se = f.querySelector('[data-e]');
    function fill(sel, list, ph, ecu) { sel.innerHTML = '<option value="">' + ph + '</option>' + list.map(function (x, i) { return '<option value="' + i + '">' + esc(x[0]) + (ecu && x[1] ? ' — ' + esc(x[1]) : '') + '</option>'; }).join(''); sel.disabled = !list.length; }
    fill(sb, d.brands, 'Marque');
    if (pb != null) { sb.value = String(pb); fill(sm, d.brands[pb][1], 'Modèle'); if (pm != null) { sm.value = String(pm); fill(se, d.brands[pb][1][pm][1], 'Motorisation · calculateur', true); } }
    sb.onchange = function () { fill(sm, sb.value ? d.brands[sb.value][1] : [], 'Modèle'); fill(se, [], 'Motorisation · calculateur'); };
    sm.onchange = function () { fill(se, sm.value ? d.brands[sb.value][1][sm.value][1] : [], 'Motorisation · calculateur', true); };
    se.onchange = function () {
      if (!se.value) return;
      var b = d.brands[sb.value], mo = b[1][sm.value], e = mo[1][se.value];
      w.remove(); user(b[0] + ' ' + mo[0] + ' · ' + e[0]); finderRes(e, focusTool, mo[0] + ' ' + e[0], b[0]);
    };
    w.appendChild(f); scroll();
  }
  function finderRes(e, focusTool, vname, vbrand) {
    var tools = e[2] || {};
    var ids = (VEH.tools || Object.keys(tools)).filter(function (t) { return tools[t]; });
    ids.sort(function (a, b) { return (REPROG.indexOf(a) < 0) - (REPROG.indexOf(b) < 0) || (tools[b].length - tools[a].length); });
    var head = '<div class="eculab-chat__ecu"><span>Calculateur</span><strong>' + esc(e[1] || 'non précisé') + '</strong></div>';
    if (focusTool) {
      var ok = !!tools[focusTool];
      head = '<div class="eculab-chat__verdict ' + (ok ? 'is-ok' : 'is-no') + '">' + (ok ? IC.check : IC.x) + '<div><strong>' + esc((P[focusTool] || {}).t || NAMES[focusTool]) + (ok ? ' : compatible' : ' : non compatible') + '</strong><span>' + (ok ? 'Méthode : ' + tools[focusTool].split('').map(function (k) { return MODES[k]; }).join(', ') : 'avec ce calculateur, d’après les listes') + '</span></div></div>' + head;
      if (ok) ids = [focusTool].concat(ids.filter(function (t) { return t !== focusTool; }));
    }
    if (!ids.length) {
      bot(head + 'Ce véhicule n’apparaît pas dans nos listes de compatibilité. D’autres solutions existent peut-être : demandez-nous.', { wide: true }).then(contact);
      return;
    }
    var html = head + (focusTool && !tools[focusTool] ? '<p>Ces interfaces sont compatibles :</p>' : '<p>' + ids.length + ' interface' + (ids.length > 1 ? 's compatibles' : ' compatible') + ' :</p>') + '<div class="eculab-chat__cards">' +
      ids.map(function (t, i) {
        var tg = tools[t].split('').map(function (k) { return { t: MODES[k] || k, cls: k === 'O' ? 'is-ok' : '' }; });
        var note = (t === 'kdcan' || t === 'enet') ? 'Avec un logiciel de flash compatible.' : (tools[t].indexOf('O') >= 0 ? 'Sans démonter le calculateur.' : 'Calculateur démonté, sur table.');
        return card(t, { tags: tg, note: note, hl: (focusTool ? t === focusTool : i === 0) });
      }).join('') + '</div><small class="eculab-chat__fine">Liste indicative : vérifiez la référence de votre calculateur ou demandez-nous confirmation avant de commander.</small>';
    bot(html, { wide: true }).then(function () {
      chips([{ label: 'Est-il dans le pack 21 000 ?', icon: 'db', run: function () { packSearch(vname || '', vbrand); } }, { label: 'Un autre véhicule', icon: 'car', run: function () { finder(); } }, { label: 'Parler à quelqu’un', run: contact }]);
    });
  }

  /* ================= Pack ================= */
  function loadPack() {
    if (PACK) return Promise.resolve(PACK);
    return fetch(root.dataset.packUrl).then(function (r) { return r.json(); }).then(function (d) {
      PACK = [];
      d.brands.forEach(function (bv) { bv[1].forEach(function (r) { PACK.push({ b: bv[0], l: r[0], m: r[1], e: r[2], s: r[3], o: r[4] || '', k: ' ' + fold(bv[0] + ' ' + r[0] + ' ' + r[1] + ' ' + r[2] + ' ' + (r[4] || '').split('').map(function (x) { return OPT[x] || ''; }).join(' ')) + ' ' }); }); });
      return PACK;
    });
  }
  function packAsk() {
    mode = 'pack';
    bot('Quel véhicule cherchez-vous dans le pack ? Tapez la marque et le modèle, par exemple <em>Golf 2.0 TDI</em>, <em>BMW 320d</em> ou <em>Clio dCi</em>.').then(function () { input.focus({ preventScroll: true }); setSugg(['Golf 2.0 TDI', 'BMW 320d', 'Audi A4 TDI']); });
  }
  var PSTOP = ['pack', 'cartographie', 'cartographies', 'carto', 'dans', 'le', 'la', 'les', 'est', 'il', 'ma', 'mon', 'voiture', 'vehicule', 'ce', 'que', 'des', 'de', 'du', 'avez', 'vous', 'une', 'un', 'pour', 'fichier', 'fichiers', 'dedans', 'inclus', 'series', 'serie', 'class', 'classe', 'klasse', 'mt', 'at', 'ch', 'cv', 'hp', 'kw', 'essence', 'diesel', 'petrol', 'avec', 'sur', 'et'];
  function pwords(q) {
    var out = [], pw = null;
    var f = fold(q).replace(/\b(19|20)\d\d\b/g, ' ').replace(/\b\d+(at|mt)\b/g, ' ');
    var m = f.match(/\b(\d{2,3}) ?(ch|cv|hp)\b/); if (m) pw = +m[1];
    f.replace(/\b\d{2,3} ?(ch|cv|hp)\b/g, ' ').split(' ').forEach(function (w) {
      if (!w || PSTOP.indexOf(w) >= 0 || w.length < 2) return;
      var syn = [w], b = w.match(/^([1-8])(\d)(\d)([dixe])$/);
      if (b) { syn.push(b[2] + '.' + b[3] + b[4], b[2] + '.' + b[3]); } /* BMW 530d -> 3.0d */
      if (/^\d\.\d$/.test(w)) syn.push(w.replace('.', '') );
      out.push({ w: w, syn: syn, k: /^[efgr]\d{2}$|^\d{3}[dixe]?$|^[a-z]+\d$/.test(w) ? 3 : 2 });
    });
    return { words: out, pw: pw };
  }
  function prank(L, q, brand) {
    var P = pwords(q), max = 0;
    if (!brand) { var fq = ' ' + fold(q) + ' '; L.some(function (r) { var b = fold(r.b); if (fq.indexOf(' ' + b + ' ') >= 0 || (b === 'volkswagen' && / vw /.test(fq)) || (b === 'mercedes benz' && / mercedes /.test(fq))) { brand = r.b; return true; } return false; }); }
    var bf = brand ? fold(brand) : null;
    var words = P.words.filter(function (x) { return !bf || bf.split(' ').indexOf(x.w) < 0 && !(bf === 'volkswagen' && x.w === 'vw') && !(bf === 'mercedes benz' && x.w === 'mercedes'); });
    words.forEach(function (x) { max += x.k; }); if (P.pw) max += 3;
    var res = [];
    L.forEach(function (r) {
      if (bf && fold(r.b) !== bf) return;
      var s = 0, all = true;
      words.forEach(function (x) { var hit = function (y) { return r.k.indexOf(' ' + y + ' ') >= 0 || (y.length > 3 && r.k.indexOf(y) >= 0); }; if (hit(x.w)) s += x.k; else if (x.syn.slice(1).some(hit)) s += x.k - 1; else all = false; });
      if (P.pw) { var m = r.l.match(/(\d+) ch/); if (m && Math.abs(+m[1] - P.pw) <= 4) s += 3; else all = false; }
      if (s > 0) res.push({ r: r, s: s, all: all });
    });
    res.sort(function (a, b) { return b.s - a.s; });
    var best = res.length ? res[0].s : 0;
    if (!best || (max && best < Math.min(3, max))) return { hits: [], exact: false };
    var keep = res.filter(function (x) { return x.s >= best * 0.75; });
    return { hits: keep.map(function (x) { return x.r; }), exact: keep[0].all };
  }
  function packSearch(q, brand) {
    mode = null;
    loadPack().then(function (L) {
      var R = prank(L, q, brand), hits = R.hits;
      if (!hits.length) {
        bot('Je ne trouve pas <strong>« ' + esc(q) + ' »</strong> dans le pack. Essayez avec la marque et le modèle (ex. <em>BMW E39 530d</em>, <em>Golf TDI</em>). Nous avons peut-être le fichier ailleurs : demandez-nous.').then(function () {
          chips([{ label: 'Chercher un autre véhicule', icon: 'db', run: packAsk }, { label: 'Parler à quelqu’un', run: contact }]);
        });
        return;
      }
      var top = hits.slice(0, 5);
      var head = R.exact ? hits.length + ' véhicule' + (hits.length > 1 ? 's' : '') + ' trouvé' + (hits.length > 1 ? 's' : '') : 'Véhicules les plus proches';
      var html = '<div class=\"eculab-chat__found' + (R.exact ? '' : ' is-near') + '\">' + IC.check + '<div><strong>' + head + '</strong><span>' + (R.exact ? 'dans le pack 21 000 cartographies' : 'vérifiez la motorisation et la puissance') + '</span></div></div><ul class=\"eculab-chat__list\">' +
        top.map(function (r) {
          var tags = r.s.split('').map(function (k) { return '<span class="eculab-chat__tag' + (k === 'O' ? '' : ' is-ok') + '">' + (STAGE[k] || k) + '</span>'; }).join('') + r.o.split('').map(function (k) { return '<span class="eculab-chat__tag is-warn">' + (OPT[k] || k) + '</span>'; }).join('');
          return '<li><strong>' + esc(r.b + ' ' + r.l) + '</strong><small>' + esc([r.m, r.e].filter(Boolean).join(' · ')) + '</small>' + (tags ? '<div class="eculab-chat__tags">' + tags + '</div>' : '') + '</li>';
        }).join('') + '</ul>' + (hits.length > 5 ? '<small class="eculab-chat__fine">+ ' + (hits.length - 5) + ' autres : précisez la motorisation, ou consultez la liste complète sur la page du pack.</small>' : '') +
        '<div class="eculab-chat__cards">' + card('pack', { tags: [{ t: '21 000+ fichiers', cls: 'is-ok' }] }) + '</div>';
      bot(html, { wide: true }).then(function () { chips([{ label: 'Chercher un autre véhicule', icon: 'db', run: packAsk }, { label: 'Quel outil pour le flasher ?', icon: 'car', run: function () { finder(); } }]); });
    }).catch(function () { bot('Je n’arrive pas à charger la liste du pack. Contactez-nous.').then(contact); });
  }

  /* ================= FAQ ================= */
  var STOP = 'a au aux avec ce ces dans de des du elle en est et il je j la le les leur lui ma mais me mes mon ne nos notre nous on ou par pas pour qu que qui sa se ses si son sur ta te tes ton tu un une vos votre vous y quoi quel quelle quels quelles comment combien puis peut peux faire fait avoir etre suis sont ai bonjour svp merci'.split(' ');
  function toks(s) { return fold(s).split(' ').filter(function (w) { return w.length > 1 && STOP.indexOf(w) < 0; }); }
  var FAQ = (cfg.faq || []).map(function (f) { return { q: f.q, a: f.a, kq: toks(f.q), kk: toks((f.k || '').replace(/,/g, ' ')), ka: toks(String(f.a || '').replace(/<[^>]+>/g, ' ')) }; });
  function score(words, f) {
    var s = 0;
    words.forEach(function (w) {
      if (f.kk.some(function (x) { return near(w, x); })) s += 3;
      else if (f.kq.some(function (x) { return near(w, x); })) s += 2;
      else if (f.ka.some(function (x) { return near(w, x); })) s += 0.5;
    });
    return s;
  }
  function faqFind(q) { var w = toks(q); if (!w.length) return []; return FAQ.map(function (f) { return { f: f, s: score(w, f) }; }).filter(function (x) { return x.s >= 2; }).sort(function (a, b) { return b.s - a.s; }); }
  function faqShow(f, rest) {
    bot('<p class="eculab-chat__q">' + esc(f.q) + '</p>' + f.a).then(function () {
      var c = [{ label: 'Merci, c’est clair', run: function () { menu('Avec plaisir ! Autre chose ?'); } }, { label: 'Ça ne répond pas à ma question', run: contact }];
      (rest || []).slice(0, 2).forEach(function (x) { c.splice(1, 0, { label: x.f.q, run: function () { faqShow(x.f); } }); });
      chips(c);
    });
  }
  function faqTopic(q, intro) {
    var r = faqFind(q).slice(0, 5);
    if (!r.length) { contact(); return; }
    bot(intro || 'Voici les questions les plus posées sur ce sujet :').then(function () {
      chips(r.map(function (x) { return { label: x.f.q, run: function () { faqShow(x.f); } }; }).concat([{ label: 'Autre chose', run: function () { menu(); } }]));
    });
  }

  /* ================= Understanding free text ================= */
  function brandIn(q) {
    if (!VEH) return -1;
    var f = ' ' + fold(q).replace(/\bvw\b/, 'volkswagen').replace(/\bmercedes\b/, 'mercedes benz') + ' ';
    var best = -1, bl = 0;
    for (var i = 0; i < VEH.brands.length; i++) { var b = fold(VEH.brands[i][0]); if (b.length > 1 && f.indexOf(' ' + b + ' ') >= 0 && b.length > bl) { best = i; bl = b.length; } }
    return best;
  }
  function modelIn(bi, q) {
    var words = ' ' + fold(q) + ' ', best = -1, bl = 0;
    VEH.brands[bi][1].forEach(function (m, i) { var n = fold(m[0]); if (n.length > 1 && words.indexOf(' ' + n + ' ') >= 0 && n.length > bl) { best = i; bl = n.length; } });
    if (best < 0) VEH.brands[bi][1].forEach(function (m, i) { var n = fold(m[0]).split(' ')[0]; if (best < 0 && n.length > 1 && words.indexOf(' ' + n + ' ') >= 0) best = i; });
    return best;
  }
  function toolIn(f) {
    if (/\bkt ?200 ?(ii|2)\b/.test(f)) return 'kt200ii';
    if (/\bkt ?200\b/.test(f)) return 'kt200';
    if (/\bkess\b/.test(f)) return 'kess';
    if (/\bk ?tag\b/.test(f)) return 'ktag';
    if (/\bmpps\b/.test(f)) return 'mpps';
    return null;
  }
  function handle(q) {
    var f = fold(q);
    setSugg(null);
    if (mode === 'pack') { packSearch(q); return; }
    if (/^(bonjour|salut|hello|bonsoir|coucou|hey|yo)\b/.test(f) && f.split(' ').length <= 3) { menu('Bonjour ! 😊 Comment puis-je vous aider ?'); return; }
    if (/^(merci|super|parfait|top|ok|d accord|nickel|genial)\b/.test(f) && f.split(' ').length <= 4) { menu('Avec plaisir ! Autre chose ?'); return; }
    if (/\b(humain|conseiller|quelqu.un|contacter|appeler|telephone|whatsapp|joindre|parler a)\b/.test(f)) { contact(); return; }
    if (/\b(pack|cartographie|cartographies|carto|cartos|21000|21 000)\b/.test(f)) {
      var rf = faqFind(q);
      var rest = toks(q).filter(function (w) { return PSTOP.indexOf(w) < 0 && !/^(21000|21|000|present|presente|dispo|disponible|trouve|existe|est-il|contient)$/.test(w); });
      if (rf.length && rf[0].s >= 5 && rest.length <= 1) faqShow(rf[0].f, rf.slice(1));
      else if (rest.length) packSearch(rest.join(' '));
      else packAsk();
      return;
    }
    var r = faqFind(q);
    var wantsTool = /\b(compatible|compatibilite|quel outil|quelle interface|quel boitier|reprog|reprogrammer|reprogrammation|flasher|stage ?1|stage ?2)\b/.test(f);
    var tool = toolIn(f);
    var isDiag = /\b(diag|diagnostic|defaut|defauts|codage|coder|voyant|inpa|ista|esys|e sys)\b/.test(f);
    busy++;
    loadVeh().catch(function () {}).then(function () {
      busy--;
      var bi = brandIn(q);
      if (isDiag && (bi < 0 || /\bbmw|mini\b/.test(f))) {
        if (/\b(e\d{2}|r5\d)\b/.test(f)) diagRes('E'); else if (/\b([fg]\d{2})\b/.test(f)) diagRes('F'); else if (bi >= 0 && !/\bbmw|mini\b/.test(f)) diagRes('M'); else diag();
        return;
      }
      if ((wantsTool || bi >= 0 || (tool && /\b(compatible|marche|fonctionne|ma voiture|mon vehicule)\b/.test(f))) && !(r.length && r[0].s >= 6 && bi < 0)) {
        var mi = bi >= 0 ? modelIn(bi, q) : -1;
        var cq = fold(q).split(' ').filter(function (w) { return w && !/^(quel|quelle|quels|outil|outils|interface|interfaces|compatible|compatibles|compatibilite|pour|ma|mon|sur|une|un|le|la|les|de|du|des|voiture|vehicule|reprog\w*|flasher|kess|ktag|kt|200|kt200|ii|kt200ii|mpps|est|il|elle|avec|marche|fonctionne|faire|faut|boitier|j|ai|je|veux|peut|on|quoi|stage|1|2|3|v2)$/.test(w); }).join(' ');
        var hits = cq ? vsearch(cq) : [];
        if (hits.length === 1) { var x = hits[0], b = VEH.brands[x.bi], m = b[1][x.mi], e = m[1][x.ei]; bot('J’ai trouvé votre véhicule : <strong>' + esc(b[0] + ' ' + m[0] + ' · ' + e[0]) + '</strong>').then(function () { finderRes(e, tool, m[0] + ' ' + e[0], b[0]); }); return; }
        if (hits.length) { finder(null, null, tool, cq); return; }
        finder(bi >= 0 ? bi : null, mi >= 0 ? mi : null, tool); return;
      }
      if (r.length) {
        if (r.length > 1 && r[1].s >= r[0].s * 0.8) {
          bot('J’ai plusieurs réponses possibles, laquelle correspond ?').then(function () {
            chips(r.slice(0, 4).map(function (x) { return { label: x.f.q, run: function () { faqShow(x.f); } }; }).concat([{ label: 'Aucune, parler à quelqu’un', run: contact }]));
          });
        } else faqShow(r[0].f, r.slice(1));
        return;
      }
      if (tool) { bot('Vous voulez savoir si le <strong>' + esc((P[tool] || {}).t || NAMES[tool]) + '</strong> est compatible avec votre véhicule ?').then(function () { chips([{ label: 'Oui, vérifier', primary: true, run: function () { finder(null, null, tool); } }, { label: 'Voir la fiche', href: (P[tool] || {}).u || '#' }]); }); return; }
      bot('Je ne suis pas sûr d’avoir bien compris. Reformulez, ou choisissez :').then(function () {
        chips([{ label: 'Trouver mon outil', icon: 'car', run: GO.finder }, { label: 'Pack 21 000', icon: 'db', run: GO.pack }, { label: 'Parler à quelqu’un', run: contact }]);
      });
    });
  }

  /* ================= Suggestions bar ================= */
  function setSugg(list) {
    var def = ['Quel outil pour ma voiture ?', 'Délais de livraison', 'Différence OBD / Boot', 'Paiement en plusieurs fois ?'];
    var L = list || def;
    sugg.innerHTML = L.map(function (s) { return '<button type="button">' + esc(s) + '</button>'; }).join('');
  }
  sugg.addEventListener('click', function (e) { var b = e.target.closest('button'); if (!b) return; send(b.textContent); });

  /* ================= Add to cart ================= */
  log.addEventListener('click', function (e) {
    var t = e.target.closest('[data-go]');
    if (t && GO[t.dataset.go]) { clearChips(); user(GOLABEL[t.dataset.go]); GO[t.dataset.go](); return; }
    var a = e.target.closest('[data-add]'); if (!a || a.disabled) return;
    a.disabled = true; a.classList.add('is-load');
    fetch(ROOT_URL + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +a.dataset.add, quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () {
        a.classList.remove('is-load'); a.classList.add('is-done'); a.innerHTML = IC.check + '<span>Ajouté</span>';
        refreshCartIcon();
        bot('<strong>' + esc(a.dataset.name) + '</strong> est dans votre panier ✓', { delay: 200 }).then(function () { chips([{ label: 'Voir le panier', primary: true, href: ROOT_URL + 'cart' }, { label: 'Continuer', run: function () { menu(); } }]); });
      })
      .catch(function () { a.disabled = false; a.classList.remove('is-load'); bot('Oups, l’ajout au panier n’a pas fonctionné. Ouvrez la fiche du produit pour le commander.'); });
  });
  function refreshCartIcon() {
    fetch(ROOT_URL + '?sections=cart-icon-bubble').then(function (r) { return r.json(); }).then(function (s) {
      var tgt = document.getElementById('cart-icon-bubble'); if (!tgt || !s['cart-icon-bubble']) return;
      var tmp = el('div', '', s['cart-icon-bubble']); var src = tmp.querySelector('#shopify-section-cart-icon-bubble') || tmp;
      tgt.innerHTML = src.innerHTML;
    }).catch(function () {});
  }

  /* ================= Open / close / send ================= */
  function send(q) {
    q = String(q || '').trim(); if (!q) return;
    input.value = ''; clearChips(); user(q); handle(q);
  }
  function start() {
    var saved = null; try { saved = JSON.parse(store(KEY) || 'null'); } catch (e) {}
    if (saved && saved.length) {
      log.innerHTML = saved.join('');
      lastBot = null; log.scrollTop = log.scrollHeight;
      menu('Rebonjour 👋 On continue ?');
    } else home();
    setSugg(null);
  }
  var started = false;
  function open() {
    panel.hidden = false; root.classList.add('is-open'); fab.setAttribute('aria-expanded', 'true');
    teaser.hidden = true; store('eculab_chat_teased', '1'); fab.classList.remove('has-dot');
    if (!started) { started = true; start(); }
    setTimeout(function () { if (window.matchMedia('(min-width: 750px)').matches) input.focus({ preventScroll: true }); }, 80);
  }
  function close() { panel.hidden = true; root.classList.remove('is-open'); fab.setAttribute('aria-expanded', 'false'); }
  root.querySelectorAll('[data-chat-open]').forEach(function (b) { b.addEventListener('click', function () { root.classList.contains('is-open') ? close() : open(); }); });
  $('[data-chat-close]').addEventListener('click', close);
  $('[data-chat-reset]').addEventListener('click', function () { store(KEY, null); log.innerHTML = ''; mode = null; home(); setSugg(null); });
  $('[data-chat-teaser-x]').addEventListener('click', function (e) { e.stopPropagation(); teaser.hidden = true; store('eculab_chat_teased', '1'); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.classList.contains('is-open')) { close(); fab.focus(); } });
  $('[data-chat-form]').addEventListener('submit', function (e) { e.preventDefault(); send(input.value); });

  /* contextual teaser */
  var ctxTool = toolFromHandle();
  var tz = cfg.teaser || 'Besoin d’aide pour choisir votre interface ?';
  if (ctxTool && REPROG.indexOf(ctxTool) >= 0) tz = 'Compatible avec votre voiture ? Je vérifie pour vous en 10 secondes.';
  else if (ctxTool === 'pack') tz = 'Votre véhicule est-il dans le pack ? Demandez-moi !';
  $('[data-chat-teaser-text]').textContent = tz;
  if (store(KEY)) fab.classList.add('has-dot');
  if (!store('eculab_chat_teased')) setTimeout(function () { if (!root.classList.contains('is-open')) { teaser.hidden = false; fab.classList.add('has-dot'); } }, ctxTool ? 6000 : 10000);
})();
